import React from 'react';
import type { FC } from 'react';
import type { OpportunityCandidate } from '@axiom/validation';
import { Flashy, Icon, Layout } from '@axiom/ui';

import { CandidateRateUtil } from '../../utils/candidate-rate-util';

interface OpportunityTalentRateIndicatorProps {
  opportunityCandidate?: OpportunityCandidate;
}

const getRateColor = (opportunityCandidate?: OpportunityCandidate) => {
  if (!CandidateRateUtil.hasSubmittedRate(opportunityCandidate)) {
    return 'iconSecondary' as const;
  }
  if (CandidateRateUtil.isOverMargin(opportunityCandidate)) {
    return 'dataVizYellow' as const;
  }
  return CandidateRateUtil.isWithinMargin(opportunityCandidate)
    ? ('dataVizGreen' as const)
    : ('dataVizYellow' as const);
};

export const OpportunityTalentRateIndicator: FC<
  OpportunityTalentRateIndicatorProps
> = ({ opportunityCandidate }) => {
  return (
    <Flashy color={getRateColor(opportunityCandidate)} name="RATE_INDICATOR">
      <Layout direction="vertical" position="middle center">
        <Icon name="dollar" />
      </Layout>
    </Flashy>
  );
};
